var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrightnessLow = function SvgIconBrightnessLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.368 3.422a.5.5 0 0 0-.733-.68l-.001.002a.5.5 0 0 0 .732.68zM4.784 4.865a.5.5 0 1 0-1 0v.02a.5.5 0 0 0 1 0zM20.22 4.866a.5.5 0 0 0-1 0v.027a.5.5 0 0 0 1 0zM3 12.583a.5.5 0 0 0-1 0v.001a.5.5 0 0 0 1 0zM21.623 13.069a.5.5 0 1 0-.242-.97h-.002a.5.5 0 1 0 .242.97zM4.283 19.802a.5.5 0 0 0 0 1h.022a.5.5 0 0 0 0-1zM19.694 19.802a.5.5 0 1 0 0 1h.025a.5.5 0 0 0 0-1zM12.368 22.422a.5.5 0 0 0-.733-.68l-.001.002a.5.5 0 0 0 .732.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.536 16.118a5 5 0 0 1-7.063.008l-.009-.009a5 5 0 1 1 7.072 0M9.172 9.753a4 4 0 0 1 5.656 0L9.172 15.41a4 4 0 0 1 0-5.657",
    clipRule: "evenodd"
  })));
};
export default SvgIconBrightnessLow;